<template>
  <v-dialog
    content-class="confirm-custom-plan-change-dialog"
    :value="true"
    :transition="false"
    @click:outside="closeConfirmCustomPlanChangeDialog"
    @keydown.esc="closeConfirmCustomPlanChangeDialog"
  >
    <v-card class="dialogs-card">
      <v-container class="px-10 pt-10 pb-4 confirm-custom-plan-change-dialog-container">
        <v-card-text class="pa-0 confirm-custom-plan-change-dialog-title">
          {{ $t('dialogs.payment.ChangeCustomPlan.title') }}
        </v-card-text>
        <v-btn
          icon
          width="fit-content"
          height="fit-content"
          class="confirm-custom-plan-change-dialog-close-button"
          @click="closeConfirmCustomPlanChangeDialog"
        >
          <close-icon class="confirm-custom-plan-change-dialog-close-icon" />
        </v-btn>
      </v-container>
      <v-container class="ma-0 px-10 py-0 confirm-custom-plan-change-dialog-body">
        <div
          v-html-safe="$t('dialogs.payment.ChangeCustomPlan.text')"
          class="confirm-custom-plan-change-dialog-body-text"
        />
      </v-container>
      <v-card-actions class="px-10 pt-6 pb-10 d-flex">
        <v-btn
          class="px-8 py-0"
          color="button-primary-background-default"
          height="48"
          @click="handleSaveCurrentPlan"
        >
          <span class="save-current-plan-btn-text">
            {{ $t('common.saveCurrentPlan') }}
          </span>
        </v-btn>
        <v-btn
          class="px-8 py-0"
          color="button-secondary-gray-background-default"
          height="48"
          @click="handleContactForCustomPlan"
        >
          <span class="change-tariff-btn-text">
            {{ $t('common.changePlan') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import CloseIcon from '@/assets/svgIcons/closeIcon.svg?inline'

export default {
  name: 'ConfirmCustomPlanChangeDialog',
  components: {
    CloseIcon
  },
  computed: {
    ...mapGetters({
      dialogs: 'plans/dialogs'
    })
  },
  methods: {
    closeConfirmCustomPlanChangeDialog () {
      this.$store.dispatch('plans/closeDialog', 'confirmCustomPlanChange')
    },
    handleSaveCurrentPlan () {
      this.closeConfirmCustomPlanChangeDialog()
      this.$store.dispatch('plans/closeDialog', 'switchPlan')
    },
    handleContactForCustomPlan () {
      this.$emit('payIfValid')
      this.closeConfirmCustomPlanChangeDialog()
    }
  }
}
</script>

<style lang="scss">
.confirm-custom-plan-change-dialog-contact-us-btn-txt {
  padding: 12px 20px;
  font-family: Roboto,serif;
  color: #B547E9;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.confirm-custom-plan-change-dialog {
  border-radius: 16px;
  width: 620px;
  .v-card__actions button {
    box-shadow: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: start;
    gap: 8px;
    border-radius: 8px;

    span {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      text-transform: none;
      letter-spacing: 0;
    }
  }
  .save-current-plan-btn-text {
    color: var(--v-button-primary-foreground-default-base);
  }
  .change-tariff-btn-text {
    color: var(--v-button-secondary-gray-foreground-default-base);
  }
}

.confirm-custom-plan-change-dialog-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.change-tariff-payment-button {
  border-radius: 50px;
  box-shadow: none;
}

.change-tariff-payment-button-text {
  font-family: Roboto,serif;
  padding: 12px 20px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.confirm-custom-plan-change-dialog-body-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--v-text-secondary-base);

  b {
    color: var(--v-text-primary-base);
    font-weight: 600;
  }
}
.confirm-custom-plan-change-dialog-contact-us-btn {
  color: #FFFFFF;
  border: 1px solid #B547E9;
  border-radius: 50px;
  box-shadow: none;
}

.confirm-custom-plan-change-dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--v-text-primary-base);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: normal;
}

.confirm-custom-plan-change-dialog-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 8px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 5px;
}

.confirm-custom-plan-change-dialog-close-button {
  fill: var(--v-old-icon-button-outline-secondary-foreground-default-base);
  right: 16px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 16px;
}

.confirm-custom-plan-change-dialog-close-icon {
  width: 24px;
  height: 24px;
  color: var(--v-button-secondary-gray-foreground-default-base);
}
</style>
